import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { OpenIdConnectService } from '../oidc/open-id-connect.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {

    private config: Microsoft.ApplicationInsights.IConfig = {
        instrumentationKey: this.oidcService.profile.aiKey
    };

    constructor(private oidcService: OpenIdConnectService) {
        if (!AppInsights.config) {
            AppInsights.downloadAndSetup(this.config);
        }

        var employeeId = oidcService.profile.employeeId;

        if (employeeId)
            AppInsights.setAuthenticatedUserContext(employeeId);
    }

    logPageView(name?: string, url?: string, properties?: any, measurements?: any, duration?: number) {
        AppInsights.trackPageView(name, url, properties, measurements, duration);
    }

    logEvent(name: string, properties?: any, measurements?: any) {
        AppInsights.trackEvent(name, properties, measurements);
    }

    logError(exception: Error, handledAt?: string, properties?: { [name: string]: string }, measurements?: { [name: string]: number }, severityLevel?: AI.SeverityLevel) {
        AppInsights.trackException(exception, handledAt, properties, measurements, severityLevel);
    }

    logTrace(message: string, properties?: { [name: string]: string }, severityLevel?: AI.SeverityLevel) {
        AppInsights.trackTrace(message, properties, severityLevel);
    }   
}
